import { requester } from "App";
import Dummy from "components/Dummy";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import CheckCircle from "components/inputs/checkBox/CheckCircle";
import InputPassword from "components/inputs/signUp/InputPassword";
import InputText from "components/inputs/signUp/InputText";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import KakaoLogin from "react-kakao-login";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import kakao from "resources/login/kakao_login_medium_wide.png";
import { AuthReducer } from "shared/redux/reducers/auth/AuthReducer";
import puffuLogo from "resources/img/vending/puffuLogoWhite.png";

function MobileLodingPage() {
    const { isMobile } = useContext(BrowserDetectContext);
    const inputs = useRef([]);
    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const [role, setRole] = useState('MEMBER'); // role 상태 초기화
    const { userName } = useContext(AuthContext);

    const navigate = useNavigate();




    // role 변경 핸들러
    const handleRoleChange = (event) => {
        setRole(event.target.value); // 선택된 role로 상태 업데이트
    };

    const signIn = () => {
        let data = { storeId: "root", userName: "", password: "", role: role };


        data.userName = inputs.current[0].getValue();
        data.password = inputs.current[1].getValue();

        
        requester.userSignIn(data, (result) => {

            if (result.code === -1) {
                if (result.message === "Invalid userName") {
                    //존자하지 않는 아이디
                    toast.error(t("noUserName"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                } else if (result.message === "Invalid credentials") {
                    //비번틀림
                    toast.error(t("noPassword"), {
                        autoClose: 1000, position: toast.POSITION.BOTTOM_CENTER
                    });
                }
            } else if (result.code === 0) {
                
                let tokenData = result.data.token;
                
                dispatch(AuthReducer.actions.setToken(tokenData));
                navigate(`/ws/root/home`)
                // modal.current.close();
                // // navigate("/");
            }
        });
    }

    const btnStyle = {
        backgroundColor: "var(--main-color)",
        border: "none",
        width: "90%",
        borderRadius: "35px",
        height: "55px"
    }

    const onClick = () => {
        let data = { data: "" }
        requester.kakaosocialTest(data, (result) => {
            
        })
    }

    const SocialKakao = () => {

        const kakaoClientId = '16a90518df394cb54916c4aa918a1a58'
        const kakaoOnSuccess = async (data) => {
            
            const idToken = data.response.access_token;  // 엑세스 토큰 백엔드로 전달
            const kakaoId = data.profile.id;
            let tokenData = { token: idToken, kakaoId: kakaoId }
            // requester.kakaoLogin(tokenData, (result) => {
            //     
            // })
            requester.kakaosocialTest(tokenData, (result) => {
                
                if (result.code === -1) {
                    
                } else if (result.code === 0) {
                    let token = result.data.token;
                    dispatch(AuthReducer.actions.setToken(token));
                }
            })

        }
        const kakaoOnFailure = (error) => {
            
        };

        return (
            <KakaoLogin
                token={kakaoClientId}
                onSuccess={kakaoOnSuccess}
                onFail={kakaoOnFailure}
            />
        )
    }
    const SocialKakao2 = () => {
        const Rest_api_key = 'e38748253f56640a5bf87d23233254b5' //REST API KEY
        const redirect_uri = 'http://localhost:3000/ws/root/memberSignIn' //Redirect URI
        // oauth 요청 URL
        const kakaoURL = `https://kauth.kakao.com/oauth/authorize?client_id=${Rest_api_key}&redirect_uri=${redirect_uri}&response_type=code`
        const handleLogin = () => {
            window.location.href = kakaoURL
        }
        return (
            <>
                <img src={kakao} onClick={handleLogin} />
            </>
        )
    }
    const signUp = () => {
        navigate("/signUp");
    }

    useEffect(() => {
        if (isMobile) {
            
        }
    }, [isMobile])

    return (
        <div style={{ display: "flex", height: "100vh", justifyContent: "center", alignItems: "center", backgroundColor: "var(--main-color)" }}>
            <FlexChild alignItems={"center"} justifyContent={"center"}>
                <VerticalFlex gap={10}>
                    <FlexChild>
                        <img src={puffuLogo} width={"60%"} />
                    </FlexChild>
                    <FlexChild>
                        <P size={20} color={"white"}>무인전자담배샵</P>
                    </FlexChild>
                </VerticalFlex>
            </FlexChild>
        </div>
    );
}

export default MobileLodingPage;